/**
 * @generated SignedSource<<0ca8886baeb8f3c1ac3eef29c212a1ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableDateRow_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_data">;
  readonly " $fragmentType": "RoomRatesTableDateRow_data";
};
export type RoomRatesTableDateRow_data$key = {
  readonly " $data"?: RoomRatesTableDateRow_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableDateRow_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableDateRow_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateCell_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a1a4fc4d5ae21112cb8e2d2466672d14";

export default node;
